import React, { useState, useEffect } from 'react'
import { Container, Spacer, Panel, Button, ToolBar } from '@sencha/ext-modern'

import { useDelayTimer } from 'tyan/public/hooks'

const FormMessage = ({ text, onClose }) => {
	const [showMe, setShowMe] = useState(false)
	const { doDelay } = useDelayTimer()

	useEffect(() => { doDelay(() => setShowMe(true), true, 50) }, [])

	return showMe && <Container shadow={false} flex={1}>
		<ToolBar defaults={{ margin: "0 10 0 0" }} docked="top" ui="app-transparent-toolbar" shadow={false} margin="0 0 0 10" padding="0 0 0 0" >
			<Panel padding="9 20 9 20" /* shadow */ >
				<div style={{ fontSize: 18 }}><b>{Tyan.t(text)}</b></div>
			</Panel>
			<Spacer />
			{onClose && <Button shadow iconCls={`x-fa fa-close`} ui="action" text={'关闭'} handler={() => onClose()} />}
		</ToolBar>
	</Container> || null
}

export default FormMessage